import React from "react";
import GleitzeitDisplay from "../GleitzeitDisplay";

const GleitzeitWidget = ({ selectedEmployee }) => {
  if (!selectedEmployee) {
    return (
      <div className="widget-placeholder">
        Kein:e Mitarbeiter:in ausgewählt.
      </div>
    );
  }

  return (
    <div className="widget-content-scroll">
      <GleitzeitDisplay selectedEmployee={selectedEmployee} />
    </div>
  );
};

export default GleitzeitWidget;
